import React,{useState, useEffect, useRef} from 'react'
import './styles.css';
import { Image } from 'antd';
import { useHistory} from 'react-router-dom'
import { bookcover, serverurl } from '../../api/api'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const CollListCard = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const counter = useRef(0);
    const imageLoaded = () => {
      counter.current += 1;
      if (counter.current >= props.data.length) {
        setLoading(false);
      }
    }
   
    const getMathVal = () => {
        const mathval = Math.floor(Math.random() * 10);
        const myArray = ['url(' + serverurl + 'public/img/joucover/1.png)',
        'url(' + serverurl + 'public/img/joucover/2.png)',
        'url(' + serverurl + 'public/img/joucover/3.png)',
        'url(' + serverurl + 'public/img/joucover/4.png)',
        'url(' + serverurl + 'public/img/joucover/5.png)',
        'url(' + serverurl + 'public/img/joucover/6.png)',
        'url(' + serverurl + 'public/img/joucover/7.png)',
        'url(' + serverurl + 'public/img/joucover/8.png)',
        'url(' + serverurl + 'public/img/joucover/9.png)',
        ];
        const returnVal = myArray[mathval]
        return returnVal;
    }

    const goToDeacriton = (item) => {
        if(props.isint){
            history.push({pathname:'/institutions/book/isbn/'+ item.eISBN,state:{contentid:item.contentId,fuzzyid:item.fuzzyId}})

        }else{
        history.push({pathname:'/book/isbn/'+ item.eISBN,state:{contentid:item.contentId,fuzzyid:item.fuzzyId}})
   
         }
        
        }

    const goToList = (item) => {
        console.log(props.titel)
        history.push({pathname:"/bookbycollection/"+props.titel,state:{name:props.cardtitel,isorg:props.isint}})}
        const trancateTitle= (title)=> {
        try{
            var length = 20;
            if (title.length > length) {
               title = title.substring(0, length)+'...';
            }
            return title;
        }catch{
            return title;

        }
        
    }



    if (props.data.length === 0) {
        return null
    }
    if(props.isLoading){
        return (
            <div className="d_card">
            <div className="list_titel">
                <Skeleton width={200}  style={{height:'30px'}} />
            </div>
            <div className="d_body">
                {props.isBook ?
                    <>
                        {props.data.map((item) => {
                            return (
                                <div className="d_continer">
                                    <div className="d_continerbody">
                                        <div className="d_img">
                                            {/* <div className="dimg" style={{width:'130px',marginBottom:'20px'}}/> */}
                                            <Skeleton width={130} className="dimg" style={{width:'130px',marginBottom:'20px'}} />
    
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </> :
                    <div className="list_body">
                        {props.data.map((item) => {
                            return (
                                <div className="journaimg" onClick={() => history.push('/journal/' + item.name + "/" + item.id)} style={{ "backgroundImage": getMathVal(), backgroundColor: "#EEF9FB" }}>
                                    <div className="pubName">{item.name}</div>
                                </div>
                            )
                        })}
                    </div>}
            </div>
        </div>)
    }

    return (
        <div className="d_card">
            <div className="list_titel">
                {props.cardtitel}
            </div>
            <div className="d_body">
                {props.isBook ?
                    <>
                        {props.data.map((item) => {
                            return (
                                <div className="d_continer">
                                    <div className="d_continerbody">
                                        <div className="d_img">
                                            <Image
                                                onClick={() => { goToDeacriton(item) }}
                                                className="dimg"
                                                preview={false}
                                                onLoad={imageLoaded}
                                                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                                                src={bookcover + item.fuzzyId + "/"+item.cover} />
                                        </div>
                                      {props.isname?<p style={{display: "block"}} className='ctitel'>{trancateTitle(item.name)}</p>:<p style={{display:  "block"}} className='ctitel'>{trancateTitle(item.contentName)}</p>} 

                                    </div>
                                </div>
                            )
                        })}
                    </> :
                    <div className="list_body">
                        {props.data.map((item) => {
                            return (
                                <div className="journaimg" onClick={() => history.push('/journal/' + item.name + "/" + item.id)} style={{ "backgroundImage": getMathVal(), backgroundColor: "#EEF9FB" }}>
                                    <div className="pubName">{item.CollListCard}</div>
                                </div>
                            )
                        })}
                    </div>}
            </div>
            <span onClick={() => goToList(props.data)} className="viewtext">VIEW ALL</span>

        </div>
    )

}
export default CollListCard;